import * as React from "react";

/**
 * Seconds left in a countdown that ticks once a second, plus a function to start it again.
 * Used for "Resend code in 0:28" cooldowns.
 */
export const useCountdown = (initialSeconds: number): [number, (seconds: number) => void] => {
  const [deadline, setDeadline] = React.useState(() => Date.now() + initialSeconds * 1000);
  const [now, setNow] = React.useState(() => Date.now());

  const remaining = Math.max(0, Math.ceil((deadline - now) / 1000));

  React.useEffect(() => {
    if (remaining <= 0) {
      return undefined;
    }
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [remaining]);

  const restart = React.useCallback((seconds: number) => {
    const start = Date.now();
    setNow(start);
    setDeadline(start + seconds * 1000);
  }, []);

  return [remaining, restart];
};

export const formatCountdown = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
};
